import { useMutation } from '@tanstack/react-query';
import useUpdateToEventResource from './use-update-to-event-resource';
import { UpdateToEventEntity } from '@mark43/cad-api';

export const useUpdateEventEntities = () => {
    const { postUpdateToEventUpdate } = useUpdateToEventResource();

    type MutateParams = {
        eventId: number;
        eventPerson?: UpdateToEventEntity;
        eventVehicle?: UpdateToEventEntity;
        parsedPerson?: UpdateToEventEntity;
        parsedVehicle?: UpdateToEventEntity;
    };

    const mutation = useMutation<true, unknown, MutateParams, unknown>({
        mutationFn: async (variables) => {
            const { eventId, eventPerson, eventVehicle, parsedPerson, parsedVehicle } = variables;

            return await postUpdateToEventUpdate(
                eventId,
                eventPerson,
                eventVehicle,
                parsedPerson,
                parsedVehicle
            );
        },
    });

    const updateEventEntities = async (
        eventId: number,
        eventPerson?: UpdateToEventEntity,
        eventVehicle?: UpdateToEventEntity,
        parsedPerson?: UpdateToEventEntity,
        parsedVehicle?: UpdateToEventEntity
    ) => {
        await mutation.mutateAsync({
            eventId,
            eventPerson,
            eventVehicle,
            parsedPerson,
            parsedVehicle,
        });
    };

    return { updateEventEntities };
};
